import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/[locale]/(profile)/my-addresses/ui/addresses-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/[locale]/(profile)/my-addresses/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/shared/ui/container/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/shared/ui/logo/index.tsx");
